<template>
  <div class="admin-dashboard">
    <header class="header">
      <h1>Admin Dashboard</h1>
    </header>
    <h2>Quick Search</h2>
    <br>
    <nav class="quick-links">
      <input
        v-model="fpId"
        type="text"
        placeholder="Enter Financial Product ID"
        @keyup.enter="handleLoadFp"
      >
      <button
        :disabled="loading"
        @click="handleLoadFp"
      >
        Open Financial Product
      </button>
      <div
        v-if="loading"
        class="loader"
      >
        Loading...
      </div>
    </nav>
    <nav class="quick-links">
      <input
        v-model="userId"
        type="text"
        placeholder="Enter User ID"
        @keyup.enter="handleLoadUser"
      >
      <button
        :disabled="loading"
        @click="handleLoadUser"
      >
        Open User
      </button>
    </nav>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { toQueryString } from '@/helpers';

export default {
  name: 'Dashboard',
  data() {
    return {
      fpId: '',
      userId: '',
      loading: false,
    };
  },
  methods: {
    ...mapActions(['getFinancialProduct']),
    async handleLoadFp() {
      this.loading = true;
      try {
        const { product } = await this.getFinancialProduct(toQueryString({
          id: this.fpId,
        }));
        const link = document.createElement('a');
        if (product.stage === 'draft') {
          link.href = `/#/financial-products/draft/${product.instrument}/${product.owner_id}/${product.created_at}`;
        } else {
          link.href = `/#/financial-products/product/${product.instrument}/${product.security_id_type}/${product.security_id}`;
        }
        link.click();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    handleLoadUser() {
      const link = document.createElement('a');
      link.href = `/#/users/onboarding-users/${this.userId}`;
      link.click();
    },
  },
};
</script>

<style scoped>
.admin-dashboard {
  font-family: Arial, sans-serif;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.header {
  width: 100%;
  background-color: #1f72b4;
  color: white;
  padding: 20px;
  text-align: center;
  margin-bottom: 20px;
}

.quick-links {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 800px;
  margin-bottom: 20px;
}

.quick-links input {
  padding: 10px;
  background-color: white;
  margin-right: 10px;
  flex: 1;
}

.quick-links button {
  background-color: #1f72b4;
  color: white;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}

.quick-links button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.loader {
  margin-left: 10px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/Dashboard.vue